import { render, staticRenderFns } from "./trafik.vue?vue&type=template&id=50b56d8a"
import script from "./trafik.vue?vue&type=script&lang=js"
export * from "./trafik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports